export default "<span class=\"role-badge\" [attr.data-role]=\"displayRole.toLowerCase()\">{{ displayRole }}</span>\n"